import { defineChannelContract } from 'shared/channels';
import type { ProjectDataDownloadProgress, ProjectDataKey } from './projectDataModel';

/** Contract of the page and the worker for the download of the selected project's data. */
export const projectDataContract = defineChannelContract<{
  requests: {
    /**
     * Resolves once the data is downloaded (the download is started when
     * missing); rejects when the download failed.
     */
    ensureDownloaded: { request: ProjectDataKey; response: void };
    /**
     * Where each download stands; downloads that neither ended nor run are
     * started again. Safe to repeat.
     */
    continueDownload: { request: ProjectDataKey[]; response: ProjectDataDownloadProgress };
  };
  events: Record<never, never>;
}>('projectDataChannel');
